import React from 'react';
export const SlateContext = React.createContext({
    mode: undefined,
    editable: undefined,
    rawSlate: {},
    slate: {},
    context: {},
    revertSlateUpdates: () => { },
    updateComponentById: () => { },
    updateSlate: () => { },
    updateBlockOutput: () => { },
});
export const useSlate = () => {
    const context = React.useContext(SlateContext);
    return context;
};
//# sourceMappingURL=slate.hook.js.map